import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SENSITIVE_ROUTES } from "../utils/constant";

export const useAuthSync = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const syncLogout = (event) => {
            // LocalStorage clear() triggers event.key === null
            // or if a specific auth key is removed
            if (event.key === "token" || event.key === null) {
                const token = localStorage.getItem("token");

                if (!token) {
                    const isSensitive = SENSITIVE_ROUTES.some(route => window.location.pathname.includes(route));

                    if (isSensitive) {
                        window.location.href = "/";
                    } else {
                        window.location.reload();
                    }
                }
            }
        };

        window.addEventListener("storage", syncLogout);
        return () => window.removeEventListener("storage", syncLogout);
    }, [navigate]);
};

export default useAuthSync;
